var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduleCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 42.48 46.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1{fill:none;}\n      .cls-2{clip-path:url(#clip-path);}\n      .cls-x1{fill:#1f8273;} /* formerly cls-3 */\n      .cls-4{fill:#f5f5f7;}\n      .cls-x2{fill:#249281;} /* formerly cls-5 */\n      .cls-6{fill:#323338;}\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 42.48,
    height: 46.41
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4792",
    "data-name": "Group 4792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7727",
    className: "cls-x1",
    d: "M32.71,7.65a2.82,2.82,0,1,0,2.81,2.82h0a2.81,2.81,0,0,0-2.81-2.82m0,4.78a2,2,0,1,1,2-2,2,2,0,0,1-2,2h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7728",
    className: "cls-x1",
    d: "M9.65,7.65a2.82,2.82,0,1,0,2.82,2.82A2.81,2.81,0,0,0,9.65,7.65h0m0,4.78a2,2,0,1,1,2-2h0a2,2,0,0,1-2,2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7729",
    className: "cls-4",
    d: "M36.84,3.93H5.63A5.63,5.63,0,0,0,0,9.56H0V40.78a5.63,5.63,0,0,0,5.63,5.63H36.84a5.64,5.64,0,0,0,5.64-5.63h0V9.56a5.64,5.64,0,0,0-5.64-5.63h0M9.65,13.28a2.82,2.82,0,1,1,2.82-2.81h0a2.81,2.81,0,0,1-2.82,2.81m23.06,0a2.82,2.82,0,1,1,2.81-2.81h0a2.81,2.81,0,0,1-2.81,2.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7730",
    className: "cls-x2",
    d: "M36.84,3.93H5.63A5.63,5.63,0,0,0,0,9.56H0V17H42.48V9.56a5.64,5.64,0,0,0-5.64-5.63h0M9.65,13.28a2.82,2.82,0,1,1,2.82-2.81h0a2.81,2.81,0,0,1-2.82,2.81m23.06,0a2.82,2.82,0,1,1,2.81-2.81h0a2.81,2.81,0,0,1-2.81,2.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7731",
    className: "cls-6",
    d: "M9.65,11.74h0A1.63,1.63,0,0,1,8,10.11H8V1.62a1.63,1.63,0,0,1,3.25-.08v8.57a1.63,1.63,0,0,1-1.63,1.63h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7732",
    className: "cls-6",
    d: "M32.71,11.74h0a1.63,1.63,0,0,1-1.63-1.63V1.62a1.63,1.63,0,0,1,3.25,0v8.49a1.63,1.63,0,0,1-1.62,1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7733",
    className: "cls-x2",
    d: "M20.66,38.58A2,2,0,0,1,19.28,38l-6.22-6.22A2,2,0,0,1,15.76,29l.06.06,4.84,4.84,9.94-9.93a2,2,0,0,1,2.76,2.76L22,38a2,2,0,0,1-1.38.57"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleCalendar);
export default __webpack_public_path__ + "static/media/scheduleCalendar.4a73897b3d8c5eaaf3af28ad9b25e93d.svg";
export { ForwardRef as ReactComponent };